<form class="form-popup" [formGroup]="formGroup">
    <mat-form-field appearance="fill">
        <mat-label>Quantity</mat-label>
          <input matInput type="number" name="Quantity Update"
                          class="fullWidth"
                          formControlName="adjustedQuantity"
          />
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Note</mat-label>
        <input
            matInput
            type="text"
            name="adjustmentNote"
            autocomplete="off"
            formControlName="adjustmentNote"
            required
        />
    </mat-form-field>

</form>
